import { render, staticRenderFns } from "./AddCampaign.vue?vue&type=template&id=cabdf590&scoped=true&"
import script from "./AddCampaign.vue?vue&type=script&lang=js&"
export * from "./AddCampaign.vue?vue&type=script&lang=js&"
import style0 from "./AddCampaign.vue?vue&type=style&index=0&id=cabdf590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cabdf590",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cabdf590')) {
      api.createRecord('cabdf590', component.options)
    } else {
      api.reload('cabdf590', component.options)
    }
    module.hot.accept("./AddCampaign.vue?vue&type=template&id=cabdf590&scoped=true&", function () {
      api.rerender('cabdf590', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/settings/campaigns/AddCampaign.vue"
export default component.exports